const PREF_ACTIONS = {
	sidebar: "SIDE_BAR",
	sidePane: "SIDE_PANE",
	fontSize: "FONT_SIZE",
	reimbursementPane: "REIMBURSEMENT_PANE",
	sidePaneNotifications: "SIDE_PANE_NOTIFICATIONS",
	openNotifications: "OPEN_NOTIFICATIONS",
	reset: "RESET",
};

const previous = JSON.parse(localStorage.getItem("preferences") || "{}");

let initialState = {
	sidePane: false,
	sidebar: true,
	fontSize: "medium",
	reimbursementPaneEnabled: true,
	notificationsOverride: false,
	...previous,
};

const updateLocalStorage = (updatedState) => {
	localStorage.setItem("preferences", JSON.stringify(updatedState));
};

const preferences = (state = initialState, { data, type }) => {
	if (type === PREF_ACTIONS.sidebar) {
		const updatedState = {
			...state,
			sidebar: data.sidebar,
		};
		updateLocalStorage(updatedState);
		return updatedState;
	} else if (type === PREF_ACTIONS.sidePane) {
		const updatedState = {
			...state,
			sidePane: data.sidePane,
			notificationsOverride: false,
		};
		updateLocalStorage(updatedState);
		return updatedState;
	} else if (type === PREF_ACTIONS.fontSize) {
		const updatedState = {
			...state,
			fontSize: data.fontSize,
		};
		updateLocalStorage(updatedState);
		return updatedState;
	} else if (type === PREF_ACTIONS.reimbursementPane) {
		const updatedState = {
			...state,
			reimbursementPaneEnabled: data.reimbursementPaneEnabled,
		};
		updateLocalStorage(updatedState);
		return updatedState;
	} else if (type === PREF_ACTIONS.sidePaneNotifications) {
		const updatedState = {
			...state,
			notificationsOverride: data.notificationsOverride,
		};
		updateLocalStorage(updatedState);
		return updatedState;
	} else if (type === PREF_ACTIONS.openNotifications) {
		const updatedState = {
			...state,
			sidePane: true,
			sidebar: false,
			notificationsOverride: true,
		};
		updateLocalStorage(updatedState);
		return updatedState;
	} else if (type === PREF_ACTIONS.reset) {
		updateLocalStorage(initialState);
		return initialState;
	} else {
		return state;
	}
};

export { PREF_ACTIONS, preferences };
